<template>
  <div class="flex column between">
    <div class="flex between align-center b4 p8">
      <div class="flex align-center bold">
        <i class="fas fa-shopping-cart r8"></i>
        Shopping Cart
      </div>
      <i
        class="fas fa-times"
        @click="$set($store.state.show, 'cart', false)"
      ></i>
    </div>
    <div
      v-if="
        (($store.state.user[$store.state.auth.uid].cart &&
          Object.keys($store.state.user[$store.state.auth.uid].cart).length >
            0) ||
          ($store.state.anon.cart &&
            Object.keys($store.state.anon.cart).length > 0)) &&
        !stage
      "
      class="p8 container m8"
    >
      <div class="flex between align-center xs-font">
        <b style="width: 40%; text-align: center" class="">Item</b>
        <b style="width: 20%; text-align: center" class="">Qty</b>
        <b style="width: 20%; text-align: center" class="">Cost</b>
        <b style="width: 20%; text-align: center" class="">Total</b>
      </div>
      <div
        class="column xs-font flexw"
        style="
          overflow: scroll;
          max-height: 100%;
          -webkit-overflow-scrolling: touch;
        "
      >
        <div
          class="flex column b16"
          :key="orderKey"
          v-for="(order, orderKey) in items"
        >
          <div class="flex md-font between align-center flexy">
            <router-link
              :to="`/i/${order.type}/${order.id}`"
              style="width: 40%"
              >{{ $store.state.ref.title[orderKey] }}</router-link
            >
            <span class="center sm-font" style="width: 20%; text-align: center">
              <i
                @click="
                  order.qty > 0
                    ? ($set(
                        $store.state.users[$store.state.auth.uid].cart[
                          orderKey
                        ],
                        3,
                        order.qty - 1
                      ),
                      $store.state.auth.uid ? updateUser() : null)
                    : null
                "
                class="fas fa-arrow-down fa-xs p4"
              ></i>
              <span class="fa-xs">{{ order.qty }}</span>
              <i
                @click="
                  $set(
                    $store.state.users[$store.state.auth.uid].cart[orderKey],
                    3,
                    order.qty + 1
                  );
                  $store.state.auth.uid ? updateUser() : null;
                "
                class="fas fa-arrow-up fa-xs p4"
              ></i>
            </span>
            <span
              class="flex center xs-font column align-center"
              style="width: 20%; text-align: center"
            >
              <div>
                <i
                  class="fa-xs fas r4"
                  :class="`fa-${
                    order.obj.currency === 'USD'
                      ? 'dollar-sign'
                      : order.obj.currency === 'GBP'
                      ? 'pound-sign'
                      : ''
                  }`"
                ></i
                >{{ order.obj.cost }}
              </div>
              <div
                v-if="order.obj['shipping and handling'] > 0"
                class="flex align-center xs-font"
              >
                <span class="xs-font r4"
                  >+ {{ order.obj["shipping and handling"] }} s&h</span
                >
              </div>
            </span>
            <span style="width: 20%; text-align: center" class="center"
              ><i
                class="fa-xs fas r4"
                :class="`fa-${
                  order.obj.currency === 'USD'
                    ? 'dollar-sign'
                    : order.obj.currency === 'GBP'
                    ? 'pound-sign'
                    : ''
                }`"
              ></i
              >{{
                Number(
                  order.obj.cost * order.qty +
                    (typeof order.obj["shipping and handling"] === "number"
                      ? order.obj["shipping and handling"]
                      : 0)
                ).toFixed(2)
              }}</span
            >
          </div>
          <div class="flex align-center between xs-font flexy p4">
            <user :userid="order.seller"></user>
            <code
              @click="
                delete $store.state.users[$store.state.auth.uid].cart[orderKey];
                $store.state.auth.uid ? updateUser() : delete items[orderKey];
              "
              class="warn-text"
            >
              <i class="far fa-trash-alt"></i> Remove
            </code>
          </div>
        </div>
        <!-- $set($store.state.users[$store.state.auth.uid].cart[orderKey], order.ts, null) -->
      </div>
    </div>
    <div
      v-if="
        (($store.state.user[$store.state.auth.uid].cart &&
          Object.keys($store.state.user[$store.state.auth.uid].cart).length >
            0) ||
          ($store.state.anon.cart &&
            Object.keys($store.state.anon.cart).length > 0)) &&
        !stage
      "
      style="align-items: center"
      class="flex around p8"
    >
      <b class="flexx flex align-center"
        ><span class="r8 md-font">Total</span>
        <i
          v-if="currency"
          class="fas"
          :class="`fa-${
            currency.toLowerCase() === 'usd'
              ? 'dollar-sign'
              : currency.toLowerCase() === 'gbp'
              ? 'pound-sign'
              : ''
          }`"
        ></i
        >{{ total }}</b
      >
      <button
        @click="stage = 'checkout'"
        class="flexx md-font success p16 box-glow"
        type="button"
      >
        <i class="fas fa-shopping-cart r8"></i> CHECKOUT
      </button>
    </div>
    <div
      class="flex between column md-font"
      style="height:100%"
      v-else-if="
        ($store.state.user[$store.state.auth.uid].cart ||
          $store.state.anon.cart) &&
        stage === 'checkout'
      "
    >
      <div style="align-items: center" class="flex between p8">
        <i class="fas fa-chevron-left" @click="stage = false"></i>
        <span class="flex center r8">
          <span class="r8">Total</span>
          <i
            v-if="currency"
            class="fas r4"
            :class="`fa-${
              currency.toLowerCase() === 'usd'
                ? 'dollar-sign'
                : currency.toLowerCase() === 'gbp'
                ? 'pound-sign'
                : ''
            }`"
          ></i
          >{{ total }}</span>
      </div>
      <div
        style="
          overflow: scroll;
          -webkit-overflow-scrolling: touch;
          height: 100%;
          width: 100%;
        "
        class="flexw"
      >
        <iform :form-model="$store.state.models.iform.checkout"></iform>
      </div>
    </div>
    <div v-else>
      <code>No items in cart.</code>
    </div>
  </div>
</template>

<script>
export default {
  name: "cart",

  computed: {
    total() {
      var newTotal = 0;
      Object.keys(this.items).forEach((item) => {
        newTotal = newTotal + this.items[item].qty * this.items[item].obj.cost;
        newTotal =
          newTotal +
          (typeof this.items[item].obj["shipping and handling"] === "number"
            ? this.items[item].obj["shipping and handling"]
            : 0);
      });
      return Number(newTotal).toFixed(2);
    },
  },
  data() {
    return {
      currency: "",
      msg: "Underground Music Events",
      showError: false,
      items: {},
      stage: false,
    };
  },
  methods: {
    getItems() {
      // Get cart from localStorage if user isn't logged in and cart exists in localStorage, else set anon cart to null
      this.$store.state.anon.cart =
        JSON.parse(window.localStorage.getItem("cart")) &&
        !this.$store.state.user[this.$store.state.auth.uid]
          ? JSON.parse(window.localStorage.getItem("cart"))
          : null;
      if (!this.$store.state.user[this.$store.state.auth.uid]) {
        this.$store.state.anon.cart = window.localStorage.getItem("cart")
          ? JSON.parse(window.localStorage.getItem("cart"))
          : {};
      } else {
        this.$store.state.user[this.$store.state.auth.uid].cart =
          this.$store.state.user[this.$store.state.auth.uid].cart || {};
      }
      // Set var rawItems to users cart if they're logged in, anon cart if they're not
      var rawItems = this.$store.state.user[this.$store.state.auth.uid]
        ? this.$store.state.user[this.$store.state.auth.uid].cart
        : this.$store.state.anon.cart;

      var rawOrders = {}; // Create empty object to collect each item
      Object.keys(rawItems).forEach((item) => {
        var weeEntry = rawItems[item];
        if (!rawOrders[item]) {
          rawOrders[item] = {
            type: weeEntry[0],
            id: weeEntry[1],
            obj: weeEntry[2],
            qty: weeEntry[3],
            seller: weeEntry[4],
            ts: Date.now(),
          };
        } else {
          if (
            rawOrders[item].obj.cost +
              (typeof rawOrders[item].obj["shipping and handling"] === "number"
                ? rawOrders[item].obj["shipping and handling"]
                : 0) ===
            weeEntry[2].cost +
              (typeof weeEntry[2]["shipping and handling"] === "number"
                ? weeEntry[2]["shipping and handling"]
                : 0)
          ) {
            rawOrders[item].qty = rawOrders[item].qty + weeEntry[3];
          } else {
            rawOrders[item + "-variant"] = {
              type: weeEntry[0],
              id: weeEntry[1],
              obj: weeEntry[2],
              qty: weeEntry[3],
              seller: weeEntry[4],
              ts: Date.now(),
            };
          }
        }
        this.currency = rawOrders[item].obj.currency;
      });
      this.$store.state.counts.cart = Object.keys(rawOrders).length;
      this.items = rawOrders;
    },
    updateUser() {
      var saveObj = {
        type: "user",
        id: this.$store.state.auth.uid,
        // noReload: true,
        data: this.$store.state.users[this.$store.state.auth.uid],
      };
      this.$store.dispatch("update", saveObj).then(() => {
        this.$set(
          this.$store.state.componentKeys,
          "cart",
          this.$store.state.componentKeys.cart + 1
        );
      });
    },
  },
  mounted() {
    this.getItems();
  },
  watch: {
    "this.$store.state.user": function (newVal) {
      console.log(newVal);
      this.getItems();
      this.total();
    },
  },
};
</script>
